import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styles from "./NewNav.module.scss";
import Logo from "../../assets/images/logoBig.png";
import LogoCutted from "../../assets/images/logoCutted.png";
import {
  loadUserData,
  logout,
  openProfileMenu,
  viewAccessRequest,
  activateFreeTrial,
  closeSuscriptionModal,
  setActivateFreeTrial,
  openSuscriptionModal,
  openMainModal,
  openFeedTextModal,
  resetProjectToEdit,
  userInfoNavStyle,
  setProjectFormStyle,
  navStyle,
} from "../../store/actions";
import { ReactComponent as Notif } from "../../assets/svg/nav-notif.svg";
import ObraPrivadaBanner from "../../assets/images/ObraPrivadaBanner.jpg";
import { ReactComponent as SegurosActive } from "../../assets/svg/segurosActive.svg";
import { ReactComponent as AlquilerActive } from "../../assets/svg/alquilerActive.svg";
import { ReactComponent as Alquiler } from "../../assets/svg/alquiler.svg";
import { ReactComponent as Negocios } from "../../assets/svg/negocios.svg";
import { ReactComponent as NegociosActive } from "../../assets/svg/negociosActive.svg";
import { ReactComponent as Seguros } from "../../assets/svg/seguros.svg";
import { ReactComponent as CalculatorEmpty } from "../../assets/svg/calculatorIconEmpty.svg";
import { ReactComponent as CaclulatorIcon } from "../../assets/svg/calculatorIcon.svg";
import { ReactComponent as NotifActive } from "../../assets/svg/nav-notif-active.svg";
import { ReactComponent as MarketPlace } from "../../assets/svg/marketplace.svg";
import { ReactComponent as MarketPlaceActive } from "../../assets/svg/marketplaceActive.svg";
import { ReactComponent as Search } from "../../assets/svg/misProyectosLittle.svg";
import { ReactComponent as SearchActive } from "../../assets/svg/misProyectosLittle.svg";
import { ReactComponent as Proyectos } from "../../assets/svg/nav-proyectos.svg";
import { ReactComponent as ProyectosActive } from "../../assets/svg/nav-proyectos-active.svg";
import { ReactComponent as Postulaciones } from "../../assets/svg/nav-postulaciones.svg";
import { ReactComponent as PostulacionesActive } from "../../assets/svg/nav-postulaciones-active.svg";
import { ReactComponent as Faq } from "../../assets/svg/FAQ.svg";
import { ReactComponent as FaqActive } from "../../assets/svg/FAQActive.svg";
import { ReactComponent as CreateIcon } from "../../assets/svg/addPublicationIcon.svg";
import { ReactComponent as LogOutIcon } from "../../assets/svg/logOutIcon.svg";
import { ReactComponent as CloseIcon } from "../../assets/svg/xClose.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/svg/arrowRightIcon.svg";
import { ReactComponent as ArrowLeftIcon } from "../../assets/svg/arrowLeftIcon.svg";
import Modal from "../../components/Modal/Modal";
import NewProject from "../../components/NewProject/NewProject";
import NewMaterialBudget from "../../components/NewMaterialBudget/NewMaterialBudget";
import Tutorial from "../../components/Tutorial/Tutorial";
import { useHistory } from "react-router-dom";
import usePremiumCheck from "../../hooks/usePremiumCheck";
import { motion } from "framer-motion";

const NewNav = ({
  userData,
  loadUserData,
  logout,
  handleReducedNav,
  tipo,
  resetProjectToEdit,
  openMainModal,
  openSuscriptionModal,
  location,
  userInfoNavStyle,
  openProfileMenu,
  newNotifications,
  solicitudesList,
  isUserPremium,
  setProjectFormStyle,
  closeSuscriptionModal,
  openFeedTextModal,
  navStyle,
  viewAccessRequest,
}) => {
  const [isActive, setIsActive] = useState("Home");
  const [changedLocation, setChangedLocation] = useState(false);
  const [modalPublication, setModalPublication] = useState(false);
  const [isOpenProject, setModalOpenProject] = useState(false);
  const [isOpenMaterialBudget, setModalOpenMaterialBudget] = useState(false);
  const [isPartVisible, setIsPartVisible] = useState(true);
  const history = useHistory();
  const premiumCheck = usePremiumCheck();


  const completeName =
    userData.type === "COMPANY"
      ? userData.razon_social
      : `${userData.name} + " " + ${userData.last_name}`;

  const handleTogglePartVisibility = () => {
    handleReducedNav();
    setIsPartVisible(!isPartVisible);
    navStyle(!isPartVisible);
  };

  useEffect(() => {
    const checkForUpdate = setInterval(() => viewAccessRequest(), 10000);
    return () => clearInterval(checkForUpdate);
  }, []);

  const handleRedirect = (title) => {
    setChangedLocation(!changedLocation);
    if (title === "Obras privadas") {
      history.push("/proyectosprivados");
    } else if (title === "Obras publicas") {
      history.push("/licitacionespublicas");
    } else if (title === "Home") {
      history.push("/dashboard");
    } else if (title === "cotizaciondemateriales") {
      history.push("/cotizaciondemateriales");
    } else if (title === "Profesionales") {
      history.push("/comunidad-edify");
    } else if (title === "notificaciones") {
      history.push("/solicitudes");
    } else if (title === "FAQ") {
      history.push("/faq");
    } else if (title === "Perfil") {
      userInfoNavStyle(false)
      history.push(`/comunidad-edify/${userData.id}/${completeName}`);
    }
  };

  useEffect(() => {
    if (history?.location?.pathname === "/dashboard") {
      setIsActive("Home");
    }
    if (history?.location?.pathname === "/proyectosprivados") {
      setIsActive("Obras privadas");
    }
    if (history?.location?.pathname === "/licitacionespublicas") {
      setIsActive("Obras publicas");
    }
    if (history?.location?.pathname === "/cotizaciondemateriales") {
      setIsActive("cotizaciondemateriales");
    }
    if (history?.location?.pathname === "/comunidad-edify") {
      setIsActive("Profesionales");
    }
    if (history?.location?.pathname === "/segurosparatrabajadoresyequipos") {
      setIsActive("Seguros");
    }
    if (history?.location?.pathname === "/alquilerdemaquinarias") {
      setIsActive("Alquiler de maquinarias");
    }
    if (history?.location?.pathname === "/solicitudes") {
      setIsActive("notificaciones");
    }
    if (history?.location?.pathname === "/faq") {
      setIsActive("FAQ");
    }
    if (
      history?.location?.pathname ===
      `/comunidad-edify/${userData.id}/${completeName}`
    ) {
      setIsActive("Perfil");
    }
  }, [changedLocation]);

  const handleCloseSesion = () => {
    openMainModal({
      title: "¿Deseas cerrar la sesión activa?",
      body: "Dejaran de llegarte las notificaciones de actividad.",
      isSuccess: false,
      confirmHandler: () => logout(true, history),
    });
  };

  const handleHelp = () => {
    setModalPublication(false);
    history.push("/faq");
  };

  const handleClose = () => {
    setModalPublication(false);
    userInfoNavStyle(false)
  }

  const handleOpenModalPublication = () => {
    setProjectFormStyle(false);
    resetProjectToEdit();
    setModalPublication(true);
    userInfoNavStyle(false);
  };

  const handleNewOpenProject = () => {
    if (isUserPremium) {
      setModalOpenProject(true);
    } else {
      openSuscriptionModal();
    }
  };

  const handleNewMaterialBudget = () => {
    if (isUserPremium) {
      setModalOpenMaterialBudget(true);
    } else {
      openSuscriptionModal();
    }
  };

  const handleNewFeedPost = () => {
    if (isUserPremium) {
      openFeedTextModal();
    } else {
      openSuscriptionModal();
    }
  };

  return (
    <div className={`${styles.generalContainer}  ${isPartVisible ? "" : styles.containerReduced}`}>
      <div className={`${styles.nav_toggle} ${modalPublication || isOpenMaterialBudget || isOpenProject ? styles.alteredZindex : ""}`} onClick={handleTogglePartVisibility}>
        {!isPartVisible ? (<ArrowRightIcon width={15} height={15} />) : (<ArrowLeftIcon width={15} height={15} />)}
      </div>
      <div className={`${styles.container} ${isPartVisible ? "" : styles.containerReduced}`}>


        <div className={styles.logo}>
          <img src={isPartVisible ? Logo : LogoCutted} alt="logo" className={`${styles.logo_icon} ${!isPartVisible && styles.smallIcon}`}/>
        </div>
        <div className={styles.nav}>
          <ul className={styles.nav_list}>
            <li
              className={`${styles.nav_navItem} ${isActive === "Home" ? styles.activeHome : ""
                }`}
              onClick={() => handleRedirect("Home")}
            >
              <div className={styles.nav_navItemIcon}>
                {isActive === "Home" ? (
                  <ProyectosActive width={20} height={20} />
                ) : (
                  <Proyectos width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>Inicio</div>
            </li>
            <li
              className={styles.nav_navItem}
              onClick={() => handleOpenModalPublication()}
            >
              <div className={styles.nav_navItemIconComunidad}>
                {isActive ? (
                  <CreateIcon width={20} height={20} />
                ) : (
                  <CreateIcon width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>Crear publicación</div>
            </li>
            <li
              className={`${styles.nav_navItem} ${isActive === "Obras privadas" ? styles.activePrivate : ""
                }`}
              onClick={() => handleRedirect("Obras privadas")}
            >
              <div
                className={`${isActive === "Obras privadas"
                  ? styles.nav_navItemIcon
                  : styles.nav_navItemIconComunidad
                  }`}
              >
                {isActive === "Obras privadas" ? (
                  <SearchActive width={20} height={20} />
                ) : (
                  <Search width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>Obras privadas</div>
            </li>
            <li
              className={`${styles.nav_navItem} ${isActive === "Obras publicas" ? styles.activePublics : ""
                }`}
              onClick={() => handleRedirect("Obras publicas")}
            >
              <div className={styles.nav_navItemIcon}>
                {isActive === "Obras publicas" ? (
                  <PostulacionesActive width={20} height={20} />
                ) : (
                  <Postulaciones width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>Obras públicas</div>
            </li>
            <li
              className={`${styles.nav_navItem} ${isActive === "cotizaciondemateriales" ? styles.activeQuotation : ""
                }`}
              onClick={() => handleRedirect("cotizaciondemateriales")}
            >
              <div
                className={`${isActive === "cotizaciondemateriales"
                  ? styles.nav_navItemIcon
                  : styles.nav_navItemIconComunidad
                  }`}
              >
                {isActive === "cotizaciondemateriales" ? (
                  <MarketPlaceActive width={20} height={20} />
                ) : (
                  <MarketPlace width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>
                Cotización de materiales
              </div>
            </li>
            <li
              className={`${styles.nav_navItem} ${isActive === "Profesionales" ? styles.activeComunidad : ""
                }`}
              onClick={() => handleRedirect("Profesionales")}
            >
              <div
                className={`${isActive === "Profesionales"
                  ? styles.nav_navItemIcon
                  : styles.nav_navItemIconComunidad
                  }`}
              >
                {isActive === "Profesionales" ? (
                  <NegociosActive width={20} height={20} />
                ) : (
                  <Negocios width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>Profesionales</div>
            </li>
            <li
              className={`${styles.nav_navItem} ${isActive === "notificaciones" ? styles.activeNotifications : ""
                }`}
              onClick={() => handleRedirect("notificaciones")}
            >
              <div className={styles.nav_navItemIcon}>
                {newNotifications > 0 && (
                  <div className={styles.nav_navItemNotification}>
                    {newNotifications}
                  </div>
                )}
                {isActive === "notificaciones" ? (
                  <NotifActive width={20} height={20} />
                ) : (
                  <Notif width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>Notificaciones</div>
            </li>
            <li
              className={`${styles.nav_navItem} ${isActive === "FAQ" ? styles.activeFaq : ""
                }`}
              onClick={() => handleRedirect("FAQ")}
            >
              <div className={styles.nav_navItemIcon}>
                {isActive === "FAQ" ? (
                  <FaqActive width={20} height={20} />
                ) : (
                  <Faq width={20} height={20} />
                )}
              </div>
              <div className={`${styles.nav_navItemText} ${!isPartVisible ? styles.hideText : ""}`}>Preguntas frecuentes</div>
            </li>
            <li
              className={`${styles.nav_navItem} ${isActive === "Perfil" ? styles.activeProfile : ""
                }`}
              onClick={() => handleRedirect("Perfil")}
            >
              <div className={styles.nav_navItemProfile}>
                <img
                  src={userData?.image_profile}
                  alt="profile"
                  className={styles.nav_navItemProfile_image}
                />
              </div>
              <div className={`${styles.nav_navItemProfile_text}  ${!isPartVisible ? styles.hideText : ""}`}>Perfil</div>
            </li>
            <li
              className={styles.nav_navItem_lastItem}
              onClick={() => handleCloseSesion()}
            >
              <div className={styles.nav_navItemIcon}>
                <LogOutIcon width={20} height={20} />
              </div>
              <div className={`${styles.nav_navItemText_logout}  ${!isPartVisible ? styles.hideText : ""}`}>Cerrar sesión</div>
            </li>
          </ul>
        </div>
        {modalPublication && (
          <motion.div
            className={styles.modal}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className={styles.modal_container}>
              <div
                className={styles.modal_container_close}
                onClick={() => handleClose()}
              >
                <CloseIcon width={15} height={15} />
              </div>
              <div className={styles.modal_container_body}>
                <div className={styles.modal_container_options}>
                  <div className={styles.modal_container_title}>
                    ¿Qué tipo de publicación podés crear?
                  </div>
                  <div className={styles.modal_container_options_container}>
                  <motion.div
                    className={styles.modal_container_options_optionPrivate}
                    initial={{ x: -200 }} animate={{ x: 0 }} transition={{ duration: 0.5 }}
                    onClick={() => {
                      handleNewOpenProject();
                      setModalPublication(false);
                    }}
                  >
                    <div className={styles.modal_container_options_optionPrivate_leftColor}></div>
                    <div className={styles.modal_container_options_optionPrivate_image}>
                      <Search width={30} height={30} />
                      <div className={styles.modal_container_options_optionPrivate_textPrivate}>
                        Obra privada
                      </div>
                    </div>
                    <ul className={styles.modal_container_options_optionPrivate_subText}>
                      <li className={styles.modal_container_options_optionPrivate_subText_highlight}> TENÉS UN PROYECTO Y NECESITAR COTIZAR UN RUBRO</li>
                      <li>- Indicá el lugar, tiempo de duración de la publicación y una descripción.</li>
                      <li>- Seleccioná un rubro que quieras cotizar(por ej: Carpinterias).</li>
                      <li>- Podés adjuntar planos, especificaciones técnicas y cómputo métrico.</li>
                      <li>- Agregá más de un rubro y planificá tus tiempos y orden de cotización.</li>
                    </ul>
                  </motion.div>
                  <motion.div
                    className={styles.modal_container_options_optionQuotation}
                    initial={{ x: 200 }} animate={{ x: 0 }} transition={{ duration: 0.5 }}
                    onClick={() => {
                      handleNewMaterialBudget();
                      setModalPublication(false);
                    }}
                  >
                    <div className={styles.modal_container_options_optionQuotation_leftColor}></div>
                    <div className={styles.modal_container_options_optionQuotation_image}>
                      <MarketPlace width={30} height={30} />
                      <div className={styles.modal_container_options_optionQuotation_textQuotation}>
                        Solicitud de cotización de materiales
                      </div>
                    </div>
                    <ul className={styles.modal_container_options_optionQuotation_subText}>
                      <li className={styles.modal_container_options_optionQuotation_subText_highlight}>NECESITÁS COTIZAR UN LISTADO DE MATERIALES</li>
                      <li>- Indicá el nombre y seleccioná una de las provincias de la lista.</li>
                      <li>- Programa las fechas de recepción de presupuestos.</li>
                      <li>- Podés elegir la moneda en la cual recibir cotización y especificar tu ciudad.</li>
                      <li>- Agregá un rubro para que los proveedores puedan cotizar.</li>
                      <li>- Adjuntá un archivo excel con la lista de materiales que necesitas cotizar.</li>
                    </ul>
                  </motion.div>
                  <motion.div
                    className={styles.modal_container_options_optionFeed}
                    initial={{ x: -200 }} animate={{ x: 0 }} transition={{ duration: 0.5 }}
                    onClick={() => {
                      handleNewFeedPost();
                      setModalPublication(false);
                    }}
                  >
                    <div className={styles.modal_container_options_optionFeed_leftColor}></div>
                    <div className={styles.modal_container_options_optionFeed_image}>
                      <ProyectosActive width={30} height={30} />
                      <div className={styles.modal_container_options_optionFeed_textFeed}>
                        Artículo en el muro
                      </div>
                    </div>
                    <ul className={styles.modal_container_options_optionFeed_subText}>
                      <li className={styles.modal_container_options_optionFeed_subText_highlight}>PUBLICITÁ TUS SERVICIOS Y PRODUCTOS EN LA COMUNIDAD</li>
                      <li>- Compartí un artículo, noticia o novedad con la comunidad.</li>
                      <li>- Podés adjuntar imágenes, videos o solo texto.</li>
                      <li>- Recibí comentarios, recomendá posteos y conectá con otros usuarios.</li>
                    </ul>
                  </motion.div>
                </div>
              </div>
              </div>
              <div className={styles.modal_container_footer} onClick={() => handleHelp()}>
                ¿Necesitas ayuda?
                <Faq width={15} height={12} />
              </div>
            </div>
          </motion.div>      
        )}
        <Modal isOpen={isOpenMaterialBudget}>
          <NewMaterialBudget
            closeModal={() => setModalOpenMaterialBudget(false)}
          />
        </Modal>
        <Modal isOpen={isOpenProject}>
          <NewProject closeModal={() => setModalOpenProject(false)} />
        </Modal>
        <Tutorial />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.general.userData,
    isLoaded: state.general.isLoaded,
    progressBarStatus: state.general.progressBarStatus,
    profileMenu: state.profile.menuShow,
    solicitudesList: state.dashboard.solicitudesList,
    isFreeTrialAvailable: state.general.isFreeTrialAvailable,
    isFreeTrialSuccess: state.profile.isFreeTrialSuccess,
    isUserPremium: state.general.isUserPremium,
    newNotifications: state.dashboard.newNotifications,
  };
};

export default connect(mapStateToProps, {
  loadUserData,
  logout,
  openProfileMenu,
  activateFreeTrial,
  closeSuscriptionModal,
  openMainModal,
  setActivateFreeTrial,
  openFeedTextModal,
  openSuscriptionModal,
  resetProjectToEdit,
  setProjectFormStyle,
  viewAccessRequest,
  navStyle,
  userInfoNavStyle,
})(NewNav);
